import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

function TablePagination({ currentPage, rowsPerPage, totalRows, onPageChange, onRowsPerPageChange }) {
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  return (
    <div className="pagination">
      <div>
        Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, totalRows)} of {totalRows}
        <select
          className="rows-select"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>
      <div className="pagination-controls">
        <button
          aria-label="left button"
          className="pagination-button"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          <ChevronsLeft size={16} />
        </button>
        <button
          aria-label="currentPage button"
          className="pagination-button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft size={16} />
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button
          className="pagination-button"
          aria-label="pagination button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRight size={16} />
        </button>
        <button
          className="pagination-button"
           aria-label="right button"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
}

export default TablePagination;